import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",      //url路径
    name: "Home",   //路由名称,我们也可以根据路由的名字来进行跳转
    component: () => import("@/views/Home.vue")
  },
  {
    path: "/about",
    name: "About",
    component:() => import("@/views/About.vue") 
  },
  {
    path: "/introduce",
    name: "Introduce",
    component:() => import("@/views/introduce.vue") 
  },
  {
    path: "/buy",
    name: "Buy",
    component:() => import("@/views/buy.vue") 
  },
  {
    path: "/policy",
    name: "Policy",
    component:() => import("@/views/policy.vue")
  },
  {
    path: "/treaty",
    name: "Treaty",
    component:() => import("@/views/treaty.vue")
  }
]

const router = createRouter({
  routes,//注册路由规则
  history: createWebHistory()//路由模式,history模式
})

export default router